export var validateEmail = function validateEmail(email) {
  var regexp =
  // eslint-disable-next-line max-len
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regexp.test(String(email).toLowerCase());
};
export var validatePhone = function validatePhone(phone) {
  var regexp = /^\+?[0-9]{10,13}$/;
  return regexp.test(String(phone).replace(/-/g, '').replace(/ /g, ''));
};